module.exports = __webpack_public_path__ + "static/media/mb2.3df49302.webp";